var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Ds-avatar"},[_c('van-grid',{attrs:{"border":_vm.gridStyle.border,"column-num":_vm.gridStyle.columnNum,"gutter":_vm.gridStyle.gutter}},_vm._l((_vm.avatar.imgList),function(item,index){return _c('van-grid-item',{key:index},[_c('van-image',{attrs:{"src":item,"round":true}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }